import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';

export const spxAdaptiveGammaLevelsGetter = function (PineJS) {
  return Promise.resolve([
    {
      name: 'SPX Adaptive GEX Levels',
      metainfo: {
        metainfoVersion: 53,
        id: "SPX Adaptive GEX Levels@tv-basicstudies-1",
        description: "SPX Adaptive GEX Levels",
        shortDescription: "SPX Adaptive GEX Levels",
        format: { type: "price" },
        linkedToSeries: true,
        is_price_study: true,
        plots: [
          { id: "call_r1", type: "line" },
          { id: "call_r2", type: "line" },
          { id: "put_r1", type: "line" },
          { id: "put_r2", type: "line" }
        ],
        defaults: {
          styles: {
            call_r1: { linestyle: 0, linewidth: 1, transparency: 0, color: "#FFA500" },
            call_r2: { linestyle: 1, linewidth: 1, transparency: 0, color: "#FFA500" },
            put_r1: { linestyle: 0, linewidth: 1, transparency: 0, color: "#ee2baa" },
            put_r2: { linestyle: 1, linewidth: 1, transparency: 0, color: "#ee2baa" }
          },
        },
        styles: {
          call_r1: { title: "Gamma Call R1" },
          call_r2: { title: "Gamma Call R2" },
          put_r1: { title: "Gamma Put R1" },
          put_r2: { title: "Gamma Put R2" }
        },
        inputs: [],
      },
      constructor: function () {
        this.main = function (ctx) {
          const { adaptiveTopOptions } = useGreeksWebsocketDataStore.getState();
          const options = adaptiveTopOptions?.spx;

          if (!options?.length) {
            return [NaN, NaN, NaN, NaN];
          }

          const matchingOptions = options
            .filter(opt => opt.timestamp * 1000 <= ctx.symbol.time)
            .sort((a, b) => b.timestamp - a.timestamp);

          if (!matchingOptions.length) return [NaN, NaN, NaN, NaN];

          const gammaOptions = matchingOptions.filter(opt => opt.greek_type === 'gamma');

          const callR1 = gammaOptions.find(opt => opt.option_type === 'call' && opt.rank === 1)?.strike_price;
          const callR2 = gammaOptions.find(opt => opt.option_type === 'call' && opt.rank === 2)?.strike_price;
          const putR1 = gammaOptions.find(opt => opt.option_type === 'put' && opt.rank === 1)?.strike_price;
          const putR2 = gammaOptions.find(opt => opt.option_type === 'put' && opt.rank === 2)?.strike_price;

          return [callR1 || NaN, callR2 || NaN, putR1 || NaN, putR2 || NaN];
        };
      },
    },
  ]);
};
